import { lazy } from 'react';
// import AddServiceRequest from '../pages/addServiceRequest.page';

// ----------------------------------------------------------------------

const ServiceListPage = lazy(() => import('../pages/OrderList.page'));

// ----------------------------------------------------------------------

const ServiceListRoutes = [
    {
        path: '/services',
        children: [
            { element: <ServiceListPage />, layout: 'default', isAuthReq: true, index: true },
            // {
            //     path: '/services/service-request',
            //     element: <AddServiceRequest />,
            //     layout: 'default',
            //     isAuthReq: true,
            // },
        ],
    },
];

export { ServiceListRoutes };
